import { Spinner, Wrap } from './style';

/**
 * The wait before a page.
 *
 * It replaces the word "Loading..." set in the browser's default type at the top-left corner of an
 * otherwise empty window — which is what three route guards showed, and it reads as a page that
 * failed rather than a page that is coming.
 *
 * It shows nothing for the first third of a second. Most of these waits are shorter than that, and
 * a spinner that appears and vanishes inside 200ms is not reassurance, it is a flicker. What is
 * left is a wait long enough to notice, which is the only one worth marking.
 *
 * Styled-components rather than Mantine's loader: one of the three places this is used sits above
 * the Mantine provider, and a spinner that depends on where it is mounted is a spinner that will
 * one day render as nothing.
 */
export default function RouteLoading() {
  return (
    <Wrap role="status" aria-label="Loading">
      <Spinner />
    </Wrap>
  );
}
